// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1kaTV","footer":"ModalUpdate_footer__1tlv-"};